import { Component, Input } from '@angular/core';

@Component({
  selector: 'tooltip-container',
  templateUrl: './tooltip-container.component.html',
  styleUrls: ['./tooltip-container.component.scss']
})
export class TooltipContainerComponent {
  @Input() theme = '';
}
